import BuildData from 'src/components/ConnectedVehicle/BuildData/BuildData';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { ConnectedVehicleActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

const mapDispatchToProps = {
    printConnectedVehicle: ConnectedVehicleActionCreator.PrintConnectedVehicle,
};

export default connect(mapStateToProps, mapDispatchToProps)(BuildData);